import {createSlice} from "@reduxjs/toolkit";
import {json} from "../../lib/appfuse-react/core/json";

const name = 'enrollment';

const initialState = {
    classInfo: {},
};

const slice = createSlice({
    name,
    initialState,
    reducers: {
        setClassInfo(state, action) {
            state.classInfo = json.toJSON(action.payload);
        },
    }
});

export const { setClassInfo } = slice.actions;

export const selectClassInfo = state => json.fromJSON(state[name].classInfo);

const enrollmentReducer = slice.reducer;
export default enrollmentReducer;